import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, DatePicker, Space, Tag, Card, Switch, Row, Col, Dropdown } from "antd";
import { Client } from "../../../core/api-client";
import { API_PREFIX_V1 } from "../../../shared/constants";
import moment from 'moment';
import { accessAllowed, showNotification } from "../../../shared/utils/utils";
import { PlusOutlined, MailOutlined, RocketOutlined, EditOutlined, DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { allPermissions } from "../../../shared/constants/constants";
import { RootState } from "../../../core/store";
import { useSelector } from "react-redux";
import { deleteEmailConfiguration } from "../../../core/store/reducers/email-configuration.slice";
import { AsyncThunkAction, Dispatch } from "@reduxjs/toolkit";

const API_RELEASES = `${API_PREFIX_V1}releases`;

type Item = { moduleName: string; changeType: string; description: string };

const ManageReleasePage: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [editing, setEditing] = useState<any>(null);
    const [form] = Form.useForm();

    const fetch = async () => {
        setLoading(true);
        try {
            const res: any = await Client.get(API_RELEASES);
            console.log(res, 'res')
            setData(res?.data?.data || []);
        } catch (e) { }
        setLoading(false);
    };

    useEffect(() => { fetch(); }, []);

    const [emailIdToDelete, setEmailIdToDelete] =
        useState<string>("");
    const [deleteModalVisible, setDeleteModalVisible] =
        useState(false);

    const handleDeleteModal = (id: string) => {
        setEmailIdToDelete(id);
        setDeleteModalVisible(true);
    };

    // const handleDelete = (id: string) => {
    //     (
    //         dispatch(deleteEmailConfiguration(id)) as any
    //     ).then((res: any) => {
    //         if (
    //             res.meta?.requestStatus === "fulfilled"
    //         ) {
    //             showNotification(
    //                 "Release deleted successfully",
    //                 "success"
    //             );

    //             setDeleteModalVisible(false);
    //             setEmailIdToDelete("");

    //             fetch();
    //         }
    //     });
    // };


    const handleDelete = async (id: string) => {
        try {


            await Client.post(`${API_RELEASES}/delete/${id}`, {});

            showNotification(
                "Release deleted successfully",
                "success"
            );

            setDeleteModalVisible(false);
            setEmailIdToDelete("");

            fetch();
        } catch (error) {
            showNotification(
                "Failed to delete release",
                "error"
            );
        }
    };


    /**
    * Confirm Delete
    */
    const onDeleteConfirm = () => {
        if (emailIdToDelete) {
            handleDelete(emailIdToDelete);
        }
    };

    /**
     * Cancel Delete
     */
    const onDeleteCancel = () => {
        setDeleteModalVisible(false);
        setEmailIdToDelete("");
    };

    const columns = [
        { title: "Version", dataIndex: "version", key: "version" },
        { title: "Date", dataIndex: "releaseDate", key: "releaseDate", render: (d: any) => d ? new Date(d).toLocaleDateString() : "" },
        { title: "Active", dataIndex: "active", key: "active", render: (v: any) => v ? <Tag color="green">Active</Tag> : <Tag>Draft</Tag> },
        { title: "Items", dataIndex: "items", key: "items", render: (items: Item[]) => items?.length || 0 },
        {
            title: "Actions",
            key: "actions",
            fixed: "right" as const,
            width: 100,

            render: (_text: any, record: any) => {
                const menuItems = [
                    ...(accessAllowed(
                        myPermissions,
                        allPermissions.UPDATE_RELEASE
                    )
                        ? [
                            {
                                key: "edit",
                                label: "Edit",
                                icon: <EditOutlined />,
                            },
                        ]
                        : []),

                    ...(accessAllowed(
                        myPermissions,
                        allPermissions.DELETE_RELEASE
                    )
                        ? [
                            {
                                key: "delete",
                                label: "Delete",
                                icon: <DeleteOutlined />,
                                danger: true,
                            },
                        ]
                        : []),
                ];

                return (
                    <Dropdown
                        menu={{
                            items: menuItems,
                            onClick: ({ key }) => {
                                if (key === "edit") {
                                    openEditor(record);
                                }

                                if (key === "delete") {
                                    handleDeleteModal(record?.id);
                                }
                            },
                        }}
                        trigger={["click"]}
                        placement="bottomRight"
                    >
                        <Button
                            type="text"
                            icon={<MoreOutlined />}
                        />
                    </Dropdown>
                );
            },
        }
    ];

    const openEditor = (row?: any) => {
        if (!row) {
            form.resetFields();
            form.setFieldsValue({ items: [] });
        } else {
            form.setFieldsValue({
                version: row.version,
                releaseDate: moment(row.releaseDate),
                active: row.active,
                items: row.items || [],
            });
            setEditing(row);
        }
        setOpen(true);
    };

    const { myPermissions } = useSelector(
        (state: RootState) => state.auth
    );
    const onFinish = async (values: any) => {
        const payload: any = {
            version: values.version,
            releaseDate: values.releaseDate.format('YYYY-MM-DD'),
            active: !!values.active,
            items: values.items || [],
        };
        try {
            if (editing) {
                await Client.put(`${API_RELEASES}/${editing.id}`, payload);
                showNotification(
                    "Release updated successfully",
                    "success"
                );
            } else {
                await Client.post(`${API_RELEASES}`, payload);
                showNotification(
                    "Release created successfully",
                    "success"
                );
            }
            setOpen(false);
            setEditing(null);
            fetch();
        } catch (e) {
            showNotification(
                editing
                    ? "Failed to update release"
                    : "Failed to create release",
                "error"
            );
        }
    };

    const headerButtons = (
        <Space
            size="middle"
            className="app-page-actions"
        >
            {accessAllowed(
                myPermissions,
                allPermissions.CREATE_RELEASE
            ) && (
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => { setEditing(null); openEditor(); }}
                    >
                        <span className="font-size-14">
                            Create Release
                        </span>
                    </Button>
                )}

            {/* <Button
          shape="circle"
          type="primary"
          icon={<BiFilterAlt />}
          onClick={() =>
            setFilterVisible(!filterVisible)
          }
          title={
            filterVisible
              ? "Hide filters"
              : "Show filters"
          }
        /> */}
        </Space>
    );

    return (
        <div className="app-page">
            {/* Page Header */}
            <div className="app-page-header">
                <Row
                    align="middle"
                    justify="space-between"
                    wrap
                >
                    <Col
                        flex="1"
                        style={{ minWidth: 0 }}
                    >
                        <div className="app-page-title-wrap">
                            <div className="app-page-icon">
                                <RocketOutlined />
                            </div>

                            <h1 className="app-page-title">
                                Release Management
                            </h1>
                        </div>

                        <p className="app-page-subtitle">
                            Release Management – Release Notes and Version Management
                        </p>
                    </Col>

                    <Col>
                        {headerButtons}
                    </Col>
                </Row>
            </div>

            <Table dataSource={data} columns={columns} rowKey="id" loading={loading} />
            <Modal open={open} title={editing ? 'Edit Release' : 'Create Release'} onCancel={() => setOpen(false)} onOk={() => form.submit()} okText="Save">
                <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ items: [] }}>
                    <Form.Item name="version" label="Version" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="releaseDate" label="Release Date" rules={[{ required: true }]}>
                        <DatePicker />
                    </Form.Item>
                    <Form.Item name="active" label="Active" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                    <Form.Item label="Items">
                        <Form.List name="items">
                            {(fields, { add, remove }) => (
                                <div>
                                    {fields.map(({ key, name, ...restField }) => (
                                        <Card style={{ marginBottom: 8 }} key={key}>
                                            <Space direction="vertical" style={{ width: '100%' }}>
                                                <Form.Item {...restField} name={[name, 'moduleName']} rules={[{ required: true }]}>
                                                    <Input placeholder="Module name" />
                                                </Form.Item>
                                                <Form.Item {...restField} name={[name, 'changeType']} rules={[{ required: true }]}>
                                                    <Input placeholder="Change type (Feature/Fix/Improvement)" />
                                                </Form.Item>
                                                <Form.Item {...restField} name={[name, 'description']} rules={[{ required: true }]}>
                                                    <Input.TextArea rows={3} placeholder="Description" />
                                                </Form.Item>
                                                <Button danger onClick={() => remove(name)}>Remove Item</Button>
                                            </Space>
                                        </Card>
                                    ))}
                                    <Button type="dashed" onClick={() => add()} style={{ width: '100%' }}>Add Item</Button>
                                </div>
                            )}
                        </Form.List>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Delete Modal */}
            <Modal
                title="Confirm Delete"
                open={deleteModalVisible}
                onOk={onDeleteConfirm}
                onCancel={onDeleteCancel}
                okText="Delete"
                cancelText="Cancel"
                okButtonProps={{
                    danger: true,
                }}
            >
                <p>
                    Are you sure you want to delete this
                    Release?
                </p>
            </Modal>
        </div>
    );
}
export default ManageReleasePage;
function dispatch(arg0: AsyncThunkAction<any, string, { state?: unknown; dispatch?: Dispatch; extra?: unknown; rejectValue?: unknown; serializedErrorType?: unknown; pendingMeta?: unknown; fulfilledMeta?: unknown; rejectedMeta?: unknown; }>): any {
    throw new Error("Function not implemented.");
}



